<template>
  <div class="container-fluid">
    <b-card class="card-transparent-background mt-3 mb-2">
      <b-card-header class="p-0">
        <b-row>
          <b-col lg="8" md="9"
            ><b-card-title class="card-title-doorder my-1"
              >Retailer Profile: {{ retailer.name }}</b-card-title
            >
          </b-col>
          <b-col lg="4" md="3" class="pr-0">
            	<div class=" justify-content-end float-sm-right">
                    <router-link :to="'/doorder/retailers/edit/'+retailer.id" class="btn-doorder-link" disabled>
                    Edit retailer </router-link>
                </div>
            
          </b-col>
        </b-row>
      </b-card-header>
    </b-card>
    <b-card no-body class="card-transparent-background mt-0">
      <b-card-body class="p-0">
        <CompanyDetails
          type="profile" status="current"
          :company_name="retailer.name"
          :company_website="retailer.company_website"
          :business_type="retailer.business_type"
          :number_business_locations="retailer.locations_count"
          :qr_scan_required.sync ="retailer.qr_scan_required"
          :invoice_reference_number="retailer.invoice_reference_number"
        />
        <LocationDetails
          type="profile"
          :locations="retailer.locations"
          class="mt-5"
        />
        <ContactDetails
          type="profile"
          :locations="retailer.locations"
          :contacts.sync="retailer.contacts"
          class="mt-5"
        />
        <ShopifyDetails 
            type="profile" status="current"
            :shopify_store_domain="retailer.shopify_store_domain"
            :shopify_app_api_key="retailer.shopify_app_api_key"
            :shopify_app_password="retailer.shopify_app_password"
            :shopify_app_secret="retailer.shopify_app_secret"
          class="mt-5"
        />
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";
import moment from "moment";

import CompanyDetails from "./profile_details_components/CompanyDetails.vue";
import LocationDetails from "./profile_details_components/LocationDetails.vue";
import ContactDetails from "./profile_details_components/ContactDetails.vue";
import PaymentDetails from "./profile_details_components/PaymentDetails.vue";
import ShopifyDetails from "./profile_details_components/ShopifyDetails.vue";

export default {
  name: "DoorderRetailerSingleView",
  components: {
    CompanyDetails,
    LocationDetails,
    ContactDetails,
    PaymentDetails,
    ShopifyDetails
  },
  data() {
    return {
      client_name: "DOORDER",
      retailer: null,
      is_loading: false,
    };
  },
  mounted() {
    this.getRetailerViewData();
  },
  methods: {
    getRetailerViewData() {
      axios
        .get("/retailer/profile/" + this.$route.params.id, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: this.client_name,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          this.retailer = response.data.retailer;
           this.retailer.qr_scan_required =  this.retailer.qr_scan_required == 1 ? true : false

          // this.events = response.data;
          //   this.setEventData(response.data);
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/doorder/retailers/ViewRetailer.vue